module.exports = __webpack_public_path__ + "img/Ivan.766b7c48.png";